<template>
  <div>
    <RightTitle title="好友请求"></RightTitle>
    <FriendTab position="request"></FriendTab>

    <!-- 好友请求列表 -->
    <div class="uar_form">
      <div class="uarf_imglist clear">
        <div v-if="dataTotal > 0">
          <div class="list" v-for="(item, index) in tableData" :key="index">
            <div class="head">
              <el-tooltip :content="item.nick">
                <a :href="item.spaceUrl" target="_blank">
                  <img :src="item.head" />
                </a>
              </el-tooltip>
            </div>
            <div class="nick inlineShow">
              <el-tooltip :content="item.nick">
                <a :href="item.spaceUrl" target="_blank" title="蝴蝶为谁开~">{{ item.nick }}</a>
              </el-tooltip>
            </div>
            <div class="oprt">
              <a href="javascript:;" @click="adopt(item)">友好通过</a>
            </div>
            <div class="oprt">
              <a href="javascript:;" v-if="item.status == 0" @click="refuse(item)">残忍拒绝</a>
              <span class="red" v-else>已拒绝</span>
            </div>
          </div>
        </div>
        <div class="noResult" v-else>暂无数据</div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="uar_form page_area" v-if="dataTotal > 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="dataTotal"
        :page-size="20"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// 加载组件
import RightTitle from "../../components/RightTitle";
import FriendTab from "../../components/FriendTab";
// 加载api
import { friendRequested, adoptFriend, refuseFriend } from "../../api/friend";
// 加载函数
import { formatQuery } from "../../utils/fn";
export default {
  name: "friend_request",
  components: {
    RightTitle,
    FriendTab
  },
  beforeRouteEnter(to, from, next) {
    friendRequested(to.query).then(res => {
      next(vm => {
        vm.tableData = res.data.list;
        vm.dataTotal = res.data.count;
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    friendRequested(to.query).then(res => {
      this.tableData = res.data.list;
      this.dataTotal = res.data.count;
    });
    next();
  },
  data() {
    return {
      tableData: [],
      dataTotal: 0
    };
  },
  methods: {
    //   友好通过
    adopt(item) {
      this.$confirm("确定要通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let that = this;
          adoptFriend({ id: item.id }).then(res => {
            if (res.status == 200) {
              this.$notify({
                title: "成功提示",
                message: res.message,
                type: "success"
              });
              that.$router.push({ query: { ...formatQuery([]), page: 1 } });
            } else {
              this.$notify({
                title: "警告",
                message: res.message,
                type: "warning"
              });
            }
          });
        })
        .catch(() => {});
    },
    // 残忍拒绝
    refuse(item) {
      this.$confirm("确定要拒绝吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let that = this;
          refuseFriend({ id: item.id }).then(res => {
            if (res.status == 200) {
              this.$notify({
                title: "成功提示",
                message: res.message,
                type: "success"
              });
              that.$router.push({
                query: { ...formatQuery([]), page: this.$route.query.page }
              });
            } else {
              this.$notify({
                title: "警告",
                message: res.message,
                type: "warning"
              });
            }
          });
        })
        .catch(() => {});
    },
    // 改变当前页
    currentChange(page) {
      this.$router.push({ query: { ...this.$route.query, page } });
    }
  }
};
</script>

<style scoped>
</style>